import script from "./ShipmentTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipmentTab.vue?vue&type=script&setup=true&lang=js"

import "./ShipmentTab.vue?vue&type=style&index=0&id=1fe95f26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fe95f26"]])

export default __exports__